module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/12-e828fa6397d3827d45a2e66fff44584f.jpg";